
import {Component, Input, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import { Router, RouterModule} from '@angular/router';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule]
})
export class MenuItemComponent{

  constructor(
    protected router: Router,
  ) {
  }

  @Input() icon: string = '';
  @Input() label: string = '';
  @Input() logout: boolean = false;
  @Input() destination: string = '';
  @Input() type: 'link' | 'button' = 'link';
  @Input() countMessage : number = 0;
  @Output() clickEvent = new EventEmitter<any>()

  onClick(): void {
    this.clickEvent.emit();
  }



}
